export default __webpack_public_path__ + "static/media/convocatoriabarrio.b6ffb809.jpeg";